export enum SANotificatonsStatus {
  AS = 'Authority Shared',
  RA = 'Release Authority',
  SR = 'Share Request',
  ACC_MOD = 'Accepted Modification',
  ACC = 'Accepted',
  UNS = 'Unshared',
  AUTH_MOD = 'Authority Modified',
  TTP = 'Transfer To Paper',
  REJ = 'Rejected',
  REJ_MOD = 'Rejected Modification',
  AUTH_DEC = 'Authority Declined',
  TIME_OUT = 'Timed Out',
  AUTR_LATER = 'Authority Release Rejected',
  APP_MOD = 'Approved Modification',
  PROC_MOD = 'Processed Modification'
}
